import { render, staticRenderFns } from "./ImportedAssignmentsComponent.vue?vue&type=template&id=52628f12&"
import script from "./ImportedAssignmentsComponent.vue?vue&type=script&lang=js&"
export * from "./ImportedAssignmentsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports